/*
 * ELASTICSEARCH CONFIDENTIAL
 * __________________
 *
 *  Copyright Elasticsearch B.V. All rights reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Elasticsearch B.V. and its suppliers, if any.
 * The intellectual and technical concepts contained herein
 * are proprietary to Elasticsearch B.V. and its suppliers and
 * may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright
 * law.  Dissemination of this information or reproduction of
 * this material is strictly forbidden unless prior written
 * permission is obtained from Elasticsearch B.V.
 */

import React from 'react'

import { EuiCheckbox, EuiFormRow } from '@elastic/eui'

import { FormattedMessage } from '@modules/i18n'

type Props = {
  value: boolean
  onChange: (value: boolean) => void
}

const IncludeByDefaultField: React.FunctionComponent<Props> = ({ value = false, onChange }) => (
  <EuiFormRow
    helpText={
      <FormattedMessage
        id='trafficFilterForm.includeByDefaultHelpText'
        defaultMessage='Any future eligible resource will apply this policy automatically.'
      />
    }
  >
    <EuiCheckbox
      id='include-by-default-checkbox'
      label={
        <FormattedMessage
          id='trafficFilterForm.includeByDefault.radioLabel'
          defaultMessage='Apply to future resources by default'
        />
      }
      checked={value}
      onChange={(e) => {
        onChange(e.target.checked)
      }}
    />
  </EuiFormRow>
)

export default IncludeByDefaultField
